import React, { memo } from 'react';

import { PageTitle } from '@components/common';
import AlarmByVendor from '@components/routes/AdminPanel/Alarms/AlarmByVendor';

import { Icons } from '@icons/icons';

import { EAdminPanelPageTitles } from '@enums/common';

import styles from './Alarms.module.scss';

const Alarms = () => {
	return (
		<div className={styles.alarmsWrapper}>
			<PageTitle
				icon={Icons.alarmInverse()}
				title={EAdminPanelPageTitles.Alarms}
			/>
			<div className={styles.whiteWrapper}>
				<AlarmByVendor />
			</div>
		</div>
	);
};

export default memo(Alarms);
